import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import NumericWidget from '@/features/dashboard/components/NumericWidget'
import { NumericWidgetSkeleton } from '@/features/dashboard/components/NumericWidgetSkeleton'
import { formatCapacity, formatRevenue } from '@/features/site/utils/revenueUtils/formatRevenueData'

type RevenuesSummaryCardsProps = {
  capacityForYear: number
  soldCapacityForYear: number
  revenuesForYear: number
  selectedYear: string
  isLoadingRevenueTimeSeries: boolean
  currency: string
}

export const RevenueSummaryCards = ({
  capacityForYear,
  soldCapacityForYear,
  revenuesForYear,
  selectedYear,
  isLoadingRevenueTimeSeries,
  currency,
}: RevenuesSummaryCardsProps) => {
  const { t } = useTranslation()

  if (isLoadingRevenueTimeSeries) {
    return (
      <Stack direction="row" gap={2} justifyContent="space-between">
        <NumericWidgetSkeleton />
        <NumericWidgetSkeleton />
        <NumericWidgetSkeleton />
      </Stack>
    )
  }

  return (
    <Stack direction="row" gap={2} justifyContent="space-between">
      <NumericWidget
        disabled
        title={t('customer_revenue.revenue_in') + ` ${selectedYear}`}
        value={formatRevenue(revenuesForYear, currency)}
        valueFontSize={24}
      />
      <NumericWidget
        disabled
        title={t('customer_revenue.capacity_in') + ` ${selectedYear}`}
        value={formatCapacity(t, capacityForYear)}
        valueFontSize={24}
      />
      <NumericWidget
        disabled
        title={t('customer_revenue.sold_in') + ` ${selectedYear}`}
        value={formatCapacity(t, soldCapacityForYear)}
        valueFontSize={24}
      />
    </Stack>
  )
}
